import Store from '../store/store'
import Router from '../router';
import { callMaui } from './mauiBridge.js';


//enumerable per gli snack

export const Snack = {
    success: 0,
    error: 1,
    cancel: 2,
    nothing: 4,
    remote: 5
}

export const STD_PASSWORD = '25201914';
export const SUPERADMIN_CODE = 1199809261;

export const callService = async function (service, param, noStatic) {

    // Estrai eventuale query string dal service: i path param vengono aggiunti PRIMA del ?
    const qIdx = service.indexOf('?');
    const servicePath = qIdx >= 0 ? service.slice(0, qIdx) : service;
    const serviceQuery = qIdx >= 0 ? service.slice(qIdx) : '';
    let serviceStatic = [process.env.VUE_APP_SERVER + servicePath];
    let paramStatic = noStatic ? [] : [Store.state.partition, Store.state.oratore.codice, Store.state.oratore.token];
    let paramList = (serviceStatic.concat(paramStatic).concat(param)).join("/") + serviceQuery;

    const start = Date.now();
    console.log(paramList);
    const response = await fetch(paramList, {
        method: 'get',
        cache: 'no-store',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Store.state.accessToken,
        }
    });

    const end = Date.now();
    let time = end - start;
    console.log("TIME EXECUTION - " + service + " : " + time + " ms");    

    if(!response) {
        console.log("RESPONSE NULL"); 
    }
    //errore di login/accesso
    if (response.status >= 400 && response.status <= 499) {
        console.log(response.status+" "+response.statusText);
        logout();
        return null;
    }

    //errore applicativo

    if (response.status >= 500) {
        console.log(response.status+" "+response.statusText);        
        return false;
    };

    const data = await response.json();
    return data;
};

// Copia testo negli appunti.
// Su Mac MAUI: navigator.clipboard non lancia errori ma non funziona → bridge diretto
// Su iOS/Android MAUI: navigator.clipboard funziona
// Su web browser: navigator.clipboard con fallback execCommand
export const copyToClipboard = async function (text) {
    const isMacMaui = !!(window.HybridWebView && window.HybridWebView.SendRawMessage
        && /Macintosh|Mac OS X/.test(navigator.userAgent)
        && !/iPhone|iPad/.test(navigator.userAgent));

    if (isMacMaui) {
        try {
            const { callMaui } = await import('./mauiBridge.js');
            await callMaui('CopyToClipboard', text);
            return;
        } catch {}
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return;
        } catch {}
    }

    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); } catch {}
    document.body.removeChild(ta);
};

export const callPost = async function (service, paramJson, byPassError) {

    const url = process.env.VUE_APP_SERVER + service;
    const start = Date.now();
    console.log('[POST]', url, paramJson);

    let response;
    try {
        response = await fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Store.state.accessToken,
            },
            body: JSON.stringify(paramJson)
        });
    } catch (err) {
        console.error('[POST] fetch error:', err);
        return byPassError ? null : false;
    }

    const time = Date.now() - start;
    console.log('[POST] status:', response.status, response.statusText, time + 'ms');

    if (response.status >= 400 && response.status <= 499) {
        const body = await response.text().catch(() => '');
        console.error('[POST] 4xx body:', body);
        return byPassError ? null : (logout(), undefined);
    };

    if (response.status >= 500) {
        const body = await response.text().catch(() => '');
        console.error('[POST] 5xx body:', body);
        return byPassError ? null : false;
    };

    const data = await response.json();
    console.log('[POST] response:', data);
    return data;
};

export const euro = function (importo) {
    return (Number(importo)).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })
};

export const gLocalData = function (stringDate) {
    if (!stringDate) return null;
    var d = new Date(stringDate);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    return [day, month, year].join('/');
};

export const gLocalDataTime = function (stringDate) {
    if (!stringDate) return null;
    var d = new Date(stringDate);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear().toString();
    let hour = d.getHours().toString();
    let min = d.getMinutes().toString();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    if (hour.length < 2) {
        hour = '0' + hour;
    }
    if (min.length < 2) {
        min = '0' + min;
    }
    return [day, month, year].join('/')+" "+hour+":"+min;
};

export const gDataCalendar = function (stringDate) {
    if (!stringDate) return null;
    var d = new Date(stringDate);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    return [year, month, day].join('-');
};

export const gCheckData = function (d) {
    var tok = d.split("/");
    var dIso = new Date([tok[2], tok[1], tok[0]].join("-"));
    return !isNaN(dIso);
};

export const gServerData = function (stringDate) {
    //da gg/mm/aaaa a aaaa-mm-gg//

    if (!stringDate) return null;
    var tok = stringDate.split("/");
    return [tok[2], tok[1], tok[0]].join('/');
};

export const logout = function () {
    callMaui('LogoutTalkOneSignal').catch(() => {});
    Store.dispatch('logout');
    Router.replace({ name: "login" });
};
